<template>
    <v-card class="overflow-hidden v-card v-sheet theme--light">
      <!-- Alert message -->
      <div>
        <v-alert :type="alert_type" :model-value="alert" :value="alert" transition="scale-transition">{{ alert_message }}</v-alert>
      </div>
      <!-- Title-->
      <header-component :headerTitle="headerText" :router-link="{name : 'ItemMaster'}" :router-link-text="action_tab"
        :return-condition="true" :component-name="'Upload Document'"/>

      <!-- search, Submit buttons -->
      <v-card class="v-card-100">
        <v-card-title style="padding: 12px 24px 12px 24px;">
          <v-row>
            <v-text-field prepend-inner-icon="mdi-magnify" v-model="search_tag" label="Search" style="max-width: 300px; margin-top: 8px;" variant="outlined"></v-text-field>
            <v-spacer></v-spacer>
            <v-btn class="ma-2" color="primary" @click="fileUpload">UPLOAD</v-btn>
          </v-row>
        </v-card-title>
      </v-card>

      <!-- table data -->
      <v-layout column>
        <!-- <v-flex md6 style="overflow:auto"> -->
          <v-data-table :dense="true" :search="search" v-model="selected" show-select disable-pagination 
          :hide-default-footer="true" :headers="headers" :items="table_data" :loading="loading" 
          loading-text="Loading Data... Please wait" class="elevation-1">
          <template #[`item.download`]="{ item }">
            <v-btn color="primary" outlined class="ma-2">DOWNLOAD</v-btn>
          </template>
          <template #bottom></template>
          </v-data-table>
        <!-- </v-flex> -->
      </v-layout>

      <!-- upload Document -->

    <v-row justify="center">
      <v-dialog v-model="fileUploadPopup" max-width="400px">
        <v-card  class="v-card-100">
          <v-card-title class="d-flex align-center">
            <span>File Upload</span>
            <v-spacer></v-spacer>
            <v-btn variant="solo" icon @click="fileUploadPopup = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-divider :thickness="2" class="border-opacity-25 m-0"/>
          <v-card-text class="pa-0">
            <form>
              <v-card-title style="display: flow-root;"> 
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-file-input
                  v-model="file"
                  :accept="acceptedFormats"
                  label="Attach the CSV file"
                  @change="changeFile"
                  color="primary"
                ></v-file-input>
                <span class="red_text">{{ requiredFiles }}</span>
                <div v-if="uploading">
                  Uploading file ({{ uploadPercentage }}%)
                  <v-progress-linear
                  :value="uploadPercentage"
                  color="blue"
                  height="10"
                  ></v-progress-linear>
                </div>
              </v-container>
            </v-card-text>
            <v-card-actions center>
              <v-spacer></v-spacer>
              <v-btn variant="flat" color="primary" class="mb-3" v-if="this.confirmButton != 'FINISH'" @click="uploadFile" :disabled="number > 0 || !file">Confirm</v-btn>
              <v-btn variant="flat" color="primary" class="mb-3" v-if="this.confirmButton == 'FINISH'" @click="fileUploadSubmit" :disabled="number > 0 || !file">Finish</v-btn>
              <v-btn variant="outlined" color="primary" class="mb-3" @click="fileUploadPopup = false">Cancel</v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </form>
        </v-card-text>
      </v-card>
      </v-dialog>
    </v-row>
      
    </v-card>
</template>
<script>
import HeaderComponent from  './../../../commoncomponents/HeaderComponent'
export default{
    components:{
        HeaderComponent
    },
    async created(){
        this.action_tab = this.$store.state.action;
    },
    data(){
        return {
            headerText : "Item Master",
            alert_type : '',
            alert_message : '',
            alert : false,
            action_tab : '',
            search_tag : '',
            headers : [
                { title: "ID", key: "id" },
                { title: "File", key: "file" },
                { title: "Status", key: "status" },
                { title: "Remarks", key: "remarks" },
                { title: "", key: "download"},
              ],
            table_data : [
              {
                id: 1,
                file: "file_1.csv",
                status: 'success',
                remarks: 'No error',
                download : "url"
              },{
                id: 2,
                file: "file_2.csv",
                status: 'fail',
                remarks: 'error in 5th line',
                download : "url"
              },
            ],
            selected : [],
            loading : false,
            search : '',
            fileUploadPopup : false,
            file : '',
            acceptedFormats: ".csv,.xlsx,.xls",
            requiredFiles: '',
            confirmButton: '',
            uploading: false,
            uploadPercentage: 0,
            number : 0,

        }
    },
    methods :{
      fileUpload(){
        this.fileUploadPopup = true
        this.number = 0;
        this.file = '';
        this.requiredFiles = '';
        this.confirmButton = 'CONFIRM';
      },
      changeFile() {
        if (this.file) {
          const allowedFormats = this.acceptedFormats.split(",");
          const fileExtension = this.file.name.split(".").pop();

          if (allowedFormats.includes("." + fileExtension)) {
            this.confirmButton = 'CONFIRM';
            return
          } else {
            this.requiredFiles = "Select only csv files";
            this.file = null;

            setTimeout(() => {
              this.requiredFiles = "";
            }, 5000);
          }
        }
      },
      uploadFile() {
        this.uploading = true;
        const reader = new FileReader();
        reader.onloadend = (event) => {
          setTimeout(() => {
            this.uploading = false;
            this.uploadPercentage = 0;
          }, 2000);
        };
        reader.onprogress = (event) => {
          if (event.lengthComputable) {
            const percentage = Math.round((event.loaded / event.total) * 100);
            this.uploadPercentage = percentage;
            this.confirmButton = 'FINISH'
          }
        };
        reader.readAsDataURL(this.file);
      },
      fileUploadSubmit(){
        this.$toast.success("updated successfully");
        this.fileUploadPopup = false;
      }
    }
}
</script>
<style scoped>
</style>